<template>
    <div>
<!--此页面用于获取登录 token 和获取用户信息的 token-->
等待登录中......
    </div>
  </template>
  
  <script>


  import { queryToken } from '@/api/login'
  
  export default {
    name: "getTokens",
    data() {
      return {
        
      };
    },
    mounted() {
      this.getToken()
   
    },
    methods: {
     async getToken(){
        let id = this.$route.query.userId
        let data=await queryToken(id)
        console.log('token',data)
        this.$store.commit('setUserId',id)
        this.$store.commit('setToken',data.hall_token)
        this.$store.commit('setUserInfoToken',data.user_token)
        this.$router.push('/serviceHome')
      },
    },
    components: {
      // HelloWorld
    },
  };
  </script>
  <style>

  </style>